import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  Card,
  CardContent,
  CardActions,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
  IconButton,
  Alert,
  Tabs,
  Tab,
  Rating,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Checkbox,
  FormGroup,
  LinearProgress,
  Stepper,
  Step,
  StepLabel
} from '@mui/material';
import {
  Assessment as AssessmentIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Send as SendIcon,
  CheckCircle as CheckCircleIcon,
  Email as EmailIcon,
  Link as LinkIcon,
  BarChart as BarChartIcon
} from '@mui/icons-material';
import { formatDate as formatDateUtil } from '../utils/format';
import { ensureLogin, fetchEvaluations, deleteEvaluation as apiDeleteEvaluation, fetchProjects, createEvaluation as apiCreateEvaluation, updateEvaluation as apiUpdateEvaluation, fetchEvaluation as apiFetchEvaluation } from '../utils/api';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useNavigate } from 'react-router-dom';

// Dados simulados para o MVP
const mockProjects = [
  { id: 1, title: 'Formação em Liderança', code: 'FL-2023-001', status: 'execution' },
  { id: 2, title: 'Desenvolvimento de Competências Digitais', code: 'DCD-2023-002', status: 'execution' },
  { id: 3, title: 'Transformação Digital para PMEs', code: 'TD-2023-003', status: 'planning' },
];

const mockEvaluationTemplates = [
  {
    id: 1,
    title: 'Avaliação de Satisfação - Formação',
    description: 'Questionário para avaliar a satisfação dos participantes com a formação.',
    type: 'satisfaction',
    target: 'participant',
    questions: [
      { id: 101, text: 'Aprendizagem e Dinâmica do Grupo — Objetivos do Curso', type: 'rating', required: true },
      { id: 102, text: 'Aprendizagem e Dinâmica do Grupo — Aprendizagem', type: 'rating', required: true },
      { id: 103, text: 'Aprendizagem e Dinâmica do Grupo — Motivação e Participação', type: 'rating', required: true },
      { id: 104, text: 'Aprendizagem e Dinâmica do Grupo — Relacionamento entre Formandos', type: 'rating', required: true },
      { id: 201, text: 'Qualidade do Programa — Utilidade dos Conteúdos do Curso', type: 'rating', required: true },
      { id: 202, text: 'Qualidade do Programa — Organização do Curso', type: 'rating', required: true },
      { id: 203, text: 'Qualidade do Programa — Duração do Curso', type: 'rating', required: true },
      { id: 301, text: 'Qualidade dos Meios de Apoio — Materiais Pedagógicos', type: 'rating', required: true },
      { id: 302, text: 'Qualidade dos Meios de Apoio — Sala de Formação e outras Instalações', type: 'rating', required: true },
      { id: 303, text: 'Qualidade dos Meios de Apoio — Equipamentos', type: 'rating', required: true },
      { id: 401, text: 'Desempenho da Equipa Pedagógica — Apoio da Coordenação', type: 'rating', required: true },
      { id: 402, text: 'Desempenho da Equipa Pedagógica — Apoio Administrativo', type: 'rating', required: true },
      { id: 403, text: 'Desempenho da Equipa Pedagógica — Linguagem', type: 'rating', required: true },
      { id: 404, text: 'Desempenho da Equipa Pedagógica — Domínio do assunto', type: 'rating', required: true },
      { id: 405, text: 'Desempenho da Equipa Pedagógica — Relacionamento com os formandos', type: 'rating', required: true },
      { id: 406, text: 'Desempenho da Equipa Pedagógica — Exercícios e Atividades Práticas', type: 'rating', required: true },
      { id: 501, text: 'Satisfação Global da Ação', type: 'rating', required: true },
      { id: 601, text: 'Opiniões e sugestões (Respostas livres)', type: 'text', required: false }
    ]
  },
  {
    id: 2,
    title: 'Avaliação de Impacto - Formando',
    description: 'Questionário de impacto para formandos/colaboradores após a ação de formação.',
    type: 'impact_formando',
    target: 'participant',
    questions: [
      { id: 2001, text: 'Dados Demográficos — Qual a sua faixa etária?', type: 'choice', required: true, options: ['Menos de 25 anos','25-34 anos','35-44 anos','45-54 anos','55 anos ou mais'] },
      { id: 2002, text: 'Dados Demográficos — Sexo', type: 'choice', required: true, options: ['Feminino','Masculino','Prefiro não responder'] },
      { id: 2003, text: 'Dados Demográficos — Há quantos anos exerce atividade profissional?', type: 'choice', required: true, options: ['Menos de 1 ano','1-5 anos','6-10 anos','Mais de 10 anos'] },
      { id: 2101, text: 'Alinhamento com Objetivos — Os conhecimentos adquiridos estavam alinhados com os meus objetivos profissionais e/ou pessoais.', type: 'rating', required: true },
      { id: 2102, text: 'Alinhamento com Objetivos — Adaptar-me mais rapidamente às mudanças no meu local de trabalho.', type: 'rating', required: true },
      { id: 2103, text: 'Alinhamento com Objetivos — Identificar e explorar novas oportunidades profissionais.', type: 'rating', required: true },
      { id: 2104, text: 'Alinhamento com Objetivos — Melhorar a minha capacidade de resolução de problemas.', type: 'rating', required: true },
      { id: 2105, text: 'Alinhamento com Objetivos — Tomar decisões mais informadas e fundamentadas.', type: 'rating', required: true },
      { id: 2201, text: 'Aplicação Prática — Utilizo as competências adquiridas no meu local de trabalho.', type: 'rating', required: true },
      { id: 2202, text: 'Aplicação Prática — A formação contribuiu para melhorar a qualidade do meu desempenho.', type: 'rating', required: true },
      { id: 2203, text: 'Aplicação Prática — A formação contribuiu para executar mais rapidamente as minhas atividades.', type: 'rating', required: true },
      { id: 2301, text: 'Impacto na Carreira — A formação foi uma forma eficaz e rápida de melhorar o meu perfil profissional.', type: 'rating', required: true },
      { id: 2302, text: 'Impacto na Carreira — A formação trouxe-me novas oportunidades de trabalho.', type: 'rating', required: true },
      { id: 2303, text: 'Impacto na Carreira — Os empregadores valorizam a formação que concluí.', type: 'rating', required: true },
      { id: 2304, text: 'Impacto na Carreira — A formação poderá contribuir para minha evolução salarial.', type: 'rating', required: true },
      { id: 2401, text: 'Rede de Contactos — A formação proporcionou oportunidades de partilha de experiências com outros profissionais.', type: 'rating', required: true },
      { id: 2402, text: 'Rede de Contactos — A participação permitiu-me estabelecer novas ligações profissionais.', type: 'rating', required: true },
      { id: 2501, text: 'Satisfação e Recomendação — Recomendaria esta formação a outros colegas.', type: 'rating', required: true },
      { id: 2502, text: 'Satisfação e Recomendação — A formação superou as minhas expectativas.', type: 'rating', required: true },
      { id: 2601, text: 'Relevância — Os conteúdos da formação são relevantes para o mercado de trabalho atual.', type: 'rating', required: true },
      { id: 2602, text: 'Relevância — A experiência de aprendizagem com o ISQ é mais envolvente comparativamente a outros programas.', type: 'rating', required: true },
      { id: 2701, text: 'Situação Profissional — Qual a sua situação profissional atual?', type: 'choice', required: true, options: ['Empregado(a)','Desempregado(a)','Outra'] },
      { id: 2702, text: 'Situação Profissional — Qual era a sua situação profissional quando iniciou a formação?', type: 'choice', required: true, options: ['Empregado(a)','Desempregado(a)','Outra'] },
      { id: 2703, text: 'Situação Profissional — Caso tenha havido mudança, em que medida considera que a formação contribuiu para essa mudança?', type: 'text', required: false }
    ]
  },
  {
    id: 4,
    title: 'Avaliação de Impacto - Empresa',
    description: 'Questionário de impacto para empresas/organizações após a ação de formação.',
    type: 'impact_empresa',
    target: 'client',
    questions: [
      { id: 4001, text: 'Dados da Empresa — Setor de atividade', type: 'choice', required: true, options: ['Indústria','Serviços','Comércio','Outro'] },
      { id: 4002, text: 'Dados da Empresa — Número de colaboradores', type: 'choice', required: true, options: ['Até 10','11-50','51-250','Mais de 250'] },
      { id: 4003, text: 'Dados da Empresa — Localização principal', type: 'choice', required: true, options: ['Norte','Centro','LVT','Alentejo','Algarve','Ilhas'] },
      { id: 4101, text: 'Alinhamento Estratégico — A formação esteve alinhada com os objetivos estratégicos da empresa.', type: 'rating', required: true },
      { id: 4102, text: 'Alinhamento Estratégico — A formação contribuiu para atingir metas organizacionais.', type: 'rating', required: true },
      { id: 4201, text: 'Adaptação e Inovação — A formação ajudou a empresa a adaptar-se mais rapidamente às mudanças do mercado.', type: 'rating', required: true },
      { id: 4202, text: 'Adaptação e Inovação — A formação fomentou a inovação nos processos internos.', type: 'rating', required: true },
      { id: 4301, text: 'Produtividade e Qualidade — Observou-se melhoria na produtividade dos colaboradores após a formação.', type: 'rating', required: true },
      { id: 4302, text: 'Produtividade e Qualidade — A qualidade dos produtos/serviços melhorou como resultado da formação.', type: 'rating', required: true },
      { id: 4401, text: 'Impacto Financeiro — A formação contribuiu para redução de custos operacionais.', type: 'rating', required: true },
      { id: 4402, text: 'Impacto Financeiro — A formação trouxe retorno sobre investimento (ROI) positivo para a empresa.', type: 'rating', required: true },
      { id: 4501, text: 'Gestão de Pessoas — A formação aumentou a motivação e retenção de colaboradores.', type: 'rating', required: true },
      { id: 4502, text: 'Gestão de Pessoas — A formação melhorou a colaboração entre equipas.', type: 'rating', required: true },
      { id: 4601, text: 'Competitividade — A formação aumentou a competitividade da empresa no mercado.', type: 'rating', required: true },
      { id: 4602, text: 'Competitividade — A formação permitiu explorar novas oportunidades de negócio.', type: 'rating', required: true },
      { id: 4701, text: 'Satisfação e Recomendação — A empresa está satisfeita com os resultados da formação.', type: 'rating', required: true },
      { id: 4702, text: 'Satisfação e Recomendação — Recomendaria esta formação a outras empresas do setor.', type: 'rating', required: true },
      { id: 4801, text: 'Indicadores Concretos — Houve impacto mensurável em indicadores da empresa?', type: 'yesno', required: true },
      { id: 4802, text: 'Indicadores Concretos — Se sim, indique quais:', type: 'text', required: false },
      { id: 4803, text: 'Indicadores Concretos — Principais benefícios percebidos:', type: 'text', required: false },
      { id: 4804, text: 'Indicadores Concretos — Principais desafios ou limitações:', type: 'text', required: false }
    ]
  }
];

  const mockActiveEvaluations = [
    {
      id: 1,
      templateId: 1,
      title: 'Avaliação de Satisfação - Formação em Liderança',
      projectId: 1,
      projectTitle: 'Formação em Liderança',
      status: 'active',
      createdAt: '2023-06-20',
      responsesCount: 12,
      targetCount: 20,
      completionRate: 60
    },
    {
      id: 2,
      templateId: 2,
      title: 'Avaliação de Impacto - Formação em Liderança',
      projectId: 1,
      projectTitle: 'Formação em Liderança',
      status: 'active',
      createdAt: '2023-06-25',
      responsesCount: 2,
      targetCount: 3,
      completionRate: 67
    },
    
    {
      id: 4,
      templateId: 1,
      title: 'Avaliação de Satisfação - Competências Digitais',
      projectId: 2,
      projectTitle: 'Desenvolvimento de Competências Digitais',
      status: 'completed',
      createdAt: '2023-05-15',
      responsesCount: 18,
      targetCount: 18,
      completionRate: 100
    }
  ];

const Evaluations = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [activeEvaluations, setActiveEvaluations] = useState([]);
  const [filteredEvaluations, setFilteredEvaluations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedEvaluation, setSelectedEvaluation] = useState(null);
  const [projectFilter, setProjectFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [creationSuccess, setCreationSuccess] = useState(false);
  const [projects, setProjects] = useState([]);

  // Formulário de criação
  const [formData, setFormData] = useState({
    templateId: '',
    projectId: '',
    title: '',
    targetEmails: '',
    sendNotification: true
  });

  // Estado para o formulário de preview
  const [previewAnswers, setPreviewAnswers] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  // Removido: estados de convites (link único público)
  const [openResultsDialog, setOpenResultsDialog] = useState(false);
  const [resultsEvaluation, setResultsEvaluation] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        await ensureLogin();
        const [evals, projs] = await Promise.all([
          fetchEvaluations(),
          fetchProjects()
        ]);
        setActiveEvaluations(evals || []);
        setFilteredEvaluations(evals || []);
        setProjects(projs || []);
        // Restaurar modelos de avaliação locais até existir endpoint real
        setTemplates(mockEvaluationTemplates);
      } catch (e) {
        console.error('Erro ao carregar avaliações', e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    // Aplicar filtros
    let result = [...activeEvaluations];
    
    if (projectFilter) {
      result = result.filter(evaluation => evaluation.projectId === parseInt(projectFilter));
    }
    
    if (statusFilter) {
      result = result.filter(evaluation => evaluation.status === statusFilter);
    }
    
    setFilteredEvaluations(result);
  }, [activeEvaluations, projectFilter, statusFilter]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleOpenCreateDialog = (template = null) => {
    if (template) {
      setSelectedTemplate(template);
      setFormData({
        ...formData,
        templateId: template.id,
        title: template.title
      });
    }
    setOpenCreateDialog(true);
  };

  const handleCloseCreateDialog = () => {
    setOpenCreateDialog(false);
    setSelectedTemplate(null);
    setFormData({
      templateId: '',
      projectId: '',
      title: '',
      targetEmails: '',
      sendNotification: true
    });
  };

  const handleOpenPreviewDialog = (evaluation = null, template = null) => {
    const qs = evaluation
      ? (Array.isArray(evaluation.questions) ? evaluation.questions : [])
      : (template && Array.isArray(template.questions) ? template.questions : []);

    setSelectedEvaluation(evaluation || null);
    setSelectedTemplate(template || null);

    const initialAnswers = {};
    qs.forEach((q, idx) => {
      const qid = q.id || idx + 1;
      initialAnswers[qid] = q.type === 'rating' ? 0 : '';
    });
    setPreviewAnswers(initialAnswers);

    setActiveStep(0);
    setOpenPreviewDialog(true);
  };

  const handleClosePreviewDialog = () => {
    setOpenPreviewDialog(false);
    setSelectedEvaluation(null);
    setSelectedTemplate(null);
    setPreviewAnswers({});
    setActiveStep(0);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked
    });
  };

  const handleAnswerChange = (questionId, value) => {
    setPreviewAnswers({
      ...previewAnswers,
      [questionId]: value
    });
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleCreateEvaluation = async () => {
    try {
      const tpl = selectedTemplate || templates.find(t => t.id === parseInt(formData.templateId));
      const questions = tpl ? tpl.questions.map(q => ({ text: q.text, type: q.type, required: q.required, options: Array.isArray(q.options) ? q.options : undefined })) : [];
      const payload = {
        title: formData.title,
        projectId: formData.projectId ? parseInt(formData.projectId) : null,
        status: 'active',
        target: tpl?.target || undefined,
        questions,
      };
      const created = await apiCreateEvaluation(payload);
      setActiveEvaluations(prev => [...prev, created]);
      setFilteredEvaluations(prev => [...prev, created]);
      setCreationSuccess(true);
      setTimeout(() => setCreationSuccess(false), 3000);

      handleCloseCreateDialog();
    } catch (e) {
      console.error('Erro ao criar avaliação', e);
      alert('Falha ao criar avaliação');
    }
  };

  const handleActivateEvaluation = async (id) => {
    try {
      await apiUpdateEvaluation(id, { status: 'active' });
      const updatedEvaluations = activeEvaluations.map(evaluation => 
        evaluation.id === id ? { ...evaluation, status: 'active' } : evaluation
      );
      setActiveEvaluations(updatedEvaluations);
      setFilteredEvaluations(updatedEvaluations);
    } catch (e) {
      alert('Não foi possível ativar a avaliação');
    }
  };

  const handleCompleteEvaluation = async (id) => {
    try {
      await ensureLogin();
      await apiUpdateEvaluation(id, { status: 'completed' });
      const updatedEvaluations = activeEvaluations.map(evaluation => 
        evaluation.id === id ? { ...evaluation, status: 'completed' } : evaluation
      );
      setActiveEvaluations(updatedEvaluations);
      setFilteredEvaluations(updatedEvaluations);
    } catch (e) {
      console.error('Erro ao concluir avaliação', e);
      alert('Não foi possível concluir (inativar) a avaliação');
    }
  };

  // Removido fluxo de reenvio de convites por email

  const handleDeleteEvaluation = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir esta avaliação?')) return;
    try {
      await ensureLogin();
      await apiDeleteEvaluation(id);
      const updatedEvaluations = activeEvaluations.filter(evaluation => evaluation.id !== id);
      setActiveEvaluations(updatedEvaluations);
      setFilteredEvaluations(updatedEvaluations);
    } catch (e) {
      console.error('Erro ao excluir avaliação', e);
      alert('Não foi possível excluir a avaliação');
    }
  };

  const handleOpenResults = async (evaluation) => {
    try {
      await ensureLogin();
      const full = await apiFetchEvaluation(evaluation.id);
      setResultsEvaluation(full);
      setOpenResultsDialog(true);
    } catch (e) {
      console.error(e);
      alert('Não foi possível carregar os resultados desta avaliação.');
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return '#4CAF50';
      case 'draft': return '#FFC107';
      case 'completed': return '#2196F3';
      case 'expired': return '#F44336';
      default: return '#999999';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'active': return 'Ativo';
      case 'draft': return 'Rascunho';
      case 'completed': return 'Concluído';
      case 'expired': return 'Expirado';
      default: return 'Desconhecido';
    }
  };

  const getTargetText = (target) => {
    switch (target) {
      case 'participant': return 'Participante';
      case 'client': return 'Cliente';
      case 'trainer': return 'Formador';
      case 'stakeholder': return 'Stakeholder';
      default: return 'Desconhecido';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return formatDateUtil(dateString);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Typography>A carregar avaliações…</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" component="div" gutterBottom>
        Avaliações e Questionários
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, gap: 1 }}>
        <FormControl variant="outlined" size="small" sx={{ minWidth: 240 }}>
          <InputLabel>Projeto para exportar</InputLabel>
          <Select value={projectFilter} onChange={(e) => setProjectFilter(e.target.value)} label="Projeto para exportar">
            <MenuItem value="">Selecione…</MenuItem>
            {projects.map((project) => (
              <MenuItem key={project.id} value={project.id}>{project.title}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button variant="outlined" onClick={async () => {
          try {
            if (!projectFilter) { alert('Selecione o projeto para exportar.'); return; }
            await ensureLogin();
            const selected = projects.find(p => String(p.id) === String(projectFilter));
            const evals = (filteredEvaluations || []).filter(ev => String(ev.projectId) === String(projectFilter));
            const rows = [];
            rows.push(['Projeto', selected?.title || '', 'ID', selected?.id || '']);
            rows.push([]);
            rows.push(['evaluation_id','evaluation_title','assignment_id','assignment_status','question_index','question_text','type','answer']);
            for (let ev of evals) {
              const full = await apiFetchEvaluation(ev.id);
              const qs = Array.isArray(full.questions) ? full.questions : [];
              const assignments = Array.isArray(full.assignments) ? full.assignments : [];
              for (let a of assignments) {
                const ans = a.answers || {};
                for (let idx = 0; idx < qs.length; idx++) {
                  const q = qs[idx];
                  const qid = (typeof q.id !== 'undefined' && q.id !== null) ? q.id : idx;
                  const label = String(q.text || '').includes('—') ? String(q.text).split('—')[1].trim() : String(q.text || `Pergunta ${idx+1}`);
                  const val = (typeof ans[qid] !== 'undefined') ? ans[qid] : ans[idx];
                  rows.push([ev.id, full.title || '', a.id || '', a.status || '', idx, label, q.type || '', (val === null || typeof val === 'undefined') ? '' : String(val)]);
                }
              }
            }
            const csv = rows.map(r => r.map(v => {
              const s = String(v).replace(/"/g,'""').replace(/\r?\n/g, ' ');
              return /[";\n]/.test(s) ? `"${s}"` : s;
            }).join(';')).join('\n');
            const bom = '\ufeff';
            const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            const dateStr = new Date().toISOString().slice(0,10);
            a.href = url;
            a.download = `avaliacoes_${selected?.title || 'projeto'}_${dateStr}.csv`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          } catch (e) {
            alert('Não foi possível exportar em Excel (CSV).');
          }
        }}>Exportar em Excel (CSV)</Button>
      </Box>
      
      {creationSuccess && (
        <Alert severity="success" sx={{ mb: 3 }}>
          Avaliação criada com sucesso!
        </Alert>
      )}
      
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="evaluation tabs">
          <Tab label="Avaliações Ativas" />
          <Tab label="Modelos de Avaliação" />
        </Tabs>
      </Box>
      
      {/* Tab de Avaliações Ativas */}
      {tabValue === 0 && (
        <>
          <Paper sx={{ p: 2, mb: 3 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={8} md={9}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
                    <InputLabel>Projeto</InputLabel>
                    <Select
                      value={projectFilter}
                      onChange={(e) => setProjectFilter(e.target.value)}
                      label="Projeto"
                    >
                      <MenuItem value="">Todos</MenuItem>
                      {projects.map((project) => (
                        <MenuItem key={project.id} value={project.id}>
                          {project.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  
                  <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                      label="Status"
                    >
                      <MenuItem value="">Todos</MenuItem>
                      <MenuItem value="draft">Rascunho</MenuItem>
                      <MenuItem value="active">Ativo</MenuItem>
                      <MenuItem value="completed">Concluído</MenuItem>
                      {/* Removido status Expirado */}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} sm={4} md={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button 
                  variant="contained" 
                  startIcon={<AddIcon />}
                  onClick={() => setOpenCreateDialog(true)}
                >
                  Nova Avaliação
                </Button>
              </Grid>
            </Grid>
          </Paper>
          
          <Grid container spacing={2}>
            {filteredEvaluations.length > 0 ? (
              filteredEvaluations.map((evaluation) => (
                <Grid item xs={12} sm={6} md={4} key={evaluation.id}>
                  <Card>
                    <CardContent>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                        <Typography variant="h6" component="div">
                          {evaluation.title}
                        </Typography>
                        <Chip 
                          label={getStatusText(evaluation.status)} 
                          size="small" 
                          sx={{ backgroundColor: getStatusColor(evaluation.status), color: 'white' }}
                        />
                      </Box>
                      
                      <Typography variant="body2" color="textSecondary" gutterBottom>
                        Projeto: {projects.find(p => p.id === (evaluation.projectId || evaluation.project_id))?.title || ''}
                      </Typography>
                      
                      <Divider sx={{ my: 1.5 }} />
                      
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Typography variant="body2" color="textSecondary">
                            Criado em:
                          </Typography>
                          <Typography variant="body2">
                            {formatDate(evaluation.createdAt)}
                          </Typography>
                        </Grid>
                      </Grid>
                      
                      {/* Removido bloco de métricas mockadas (Taxa de Resposta) */}
                    </CardContent>
                    <CardActions sx={{ flexWrap: 'wrap', gap: 1 }}>
                      {evaluation.status === 'draft' && (
                        <Button 
                          size="small" 
                          onClick={() => handleActivateEvaluation(evaluation.id)}
                        >
                          Ativar
                        </Button>
                      )}
                      
                      {/* Removido botão de reenvio por email */}

                      {evaluation.status === 'active' && (
                        <IconButton
                          size="small"
                          title="Copiar link público"
                          aria-label="copy-public-link"
                          onClick={() => navigator.clipboard.writeText(`${window.location.origin}/public/evaluation/by-id/${evaluation.id}`)}
                        >
                          <LinkIcon />
                        </IconButton>
                      )}
                      <Button size="small" onClick={async () => {
                        try {
                          await ensureLogin();
                          const full = await apiFetchEvaluation(evaluation.id);
                          const doc = new jsPDF('p', 'mm', 'a4');
                          doc.setFontSize(14);
                          doc.text(String(full.title || `Avaliação ${full.id}`), 10, 15);
                          doc.setFontSize(10);
                          doc.text(`Concluídos: ${(full.assignments || []).filter(a => a.status === 'completed').length}`, 10, 22);
                          let y = 30;
                          const qs = Array.isArray(full.questions) ? full.questions : [];
                          qs.forEach((q, idx) => {
                            if (y > 270) { doc.addPage(); y = 15; }
                            const qid = (typeof q.id !== 'undefined' && q.id !== null) ? q.id : idx;
                            const completed = (full.assignments || []).filter(a => a.status === 'completed');
                            const values = completed.map(a => {
                              const ans = a.answers || {};
                              return (typeof ans[qid] !== 'undefined') ? ans[qid] : ans[idx];
                            }).filter(v => typeof v !== 'undefined' && v !== null);
                            let summary = '';
                            if (q.type === 'rating') {
                              const nums = values.map(v => Number(v)).filter(n => !Number.isNaN(n));
                              const avg = nums.length ? (nums.reduce((s, n) => s + n, 0) / nums.length).toFixed(2) : '—';
                              summary = `Média: ${avg} (${nums.length})`;
                            } else if (q.type === 'yesno') {
                              const yes = values.filter(v => String(v).toLowerCase() === 'yes').length;
                              const no = values.filter(v => String(v).toLowerCase() === 'no').length;
                              summary = `Sim: ${yes} · Não: ${no}`;
                            } else if (q.type === 'choice') {
                              const opts = Array.isArray(q.options) ? q.options : [];
                              const counts = opts.map(o => ({ o, c: values.filter(v => String(v) === String(o)).length }));
                              summary = counts.length ? counts.map(({o,c}) => `${o}: ${c}`).join(' · ') : `Respostas: ${values.length}`;
                            } else if (q.type === 'text') {
                              const texts = values.map(v => String(v)).filter(t => t && t.trim().length);
                              summary = texts.length ? `Respostas: ${texts.length}` : 'Sem respostas textuais';
                            } else {
                              summary = `Respostas: ${values.length}`;
                            }
                            const label = String(q.text || '').includes('—') ? String(q.text).split('—')[1].trim() : String(q.text || 'Pergunta');
                            doc.text(`${idx + 1}. ${label}`, 10, y);
                            y += 5;
                            doc.text(summary, 12, y);
                            y += 7;
                          });
                          const dateStr = new Date().toISOString().slice(0, 10);
                          doc.save(`avaliacao_${evaluation.id}_${dateStr}.pdf`);
                        } catch (e) {
                          alert('Não foi possível exportar esta avaliação.');
                        }
                      }}>Exportar PDF</Button>

                      {evaluation.status === 'active' && (
                        <Button 
                          size="small" 
                          color="warning"
                          onClick={() => handleCompleteEvaluation(evaluation.id)}
                        >
                          Concluir
                        </Button>
                      )}
                      
                      {(evaluation.status === 'active' || evaluation.status === 'completed') && (
                        <Button 
                          size="small" 
                          startIcon={<BarChartIcon />}
                          onClick={() => handleOpenResults(evaluation)}
                        >
                          Resultados
                        </Button>
                      )}
                      
                      <Button 
                        size="small" 
                        color="error"
                        onClick={() => handleDeleteEvaluation(evaluation.id)}
                      >
                        Excluir
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Paper sx={{ p: 3, textAlign: 'center' }}>
                  <Typography variant="body1">
                    Nenhuma avaliação encontrada com os filtros selecionados.
                  </Typography>
                </Paper>
              </Grid>
            )}
          </Grid>
        </>
      )}
      
      {/* Tab de Modelos de Avaliação */}
      {tabValue === 1 && (
        <Grid container spacing={3}>
          {templates.map((template) => (
            <Grid item xs={12} sm={6} md={4} key={template.id}>
              <Card>
                <CardContent>
                  <Typography variant="h6" component="div" gutterBottom>
                    {template.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" paragraph>
                    {template.description}
                  </Typography>
                  
                  <Divider sx={{ my: 1.5 }} />
                  
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Tipo:
                      </Typography>
                      <Chip 
                        label={template.type === 'satisfaction' ? 'Satisfação' : template.type === 'impact' ? 'Impacto' : 'Desempenho'} 
                        size="small" 
                        color="primary"
                        variant="outlined"
                        sx={{ mt: 0.5 }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Destinatário:
                      </Typography>
                      <Chip 
                        label={getTargetText(template.target)} 
                        size="small" 
                        color="secondary"
                        variant="outlined"
                        sx={{ mt: 0.5 }}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 1 }}>
                      <Typography variant="body2" color="textSecondary">
                        Perguntas: {Array.isArray(template.questions) ? template.questions.length : 0}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Button 
                    size="small" 
                    color="primary"
                    onClick={() => handleOpenCreateDialog(template)}
                  >
                    Usar Modelo
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      
      {/* Removida aba de Resultados e Relatórios (conteúdo duplicado) */}
      
      {/* Diálogo para criar avaliação */}
      <Dialog open={openCreateDialog} onClose={handleCloseCreateDialog} maxWidth="md" fullWidth>
        <DialogTitle>
          Criar Nova Avaliação
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {!selectedTemplate && (
              <Grid item xs={12}>
                <FormControl fullWidth required>
                  <InputLabel>Modelo de Avaliação</InputLabel>
                  <Select
                    name="templateId"
                    value={formData.templateId}
                    onChange={handleInputChange}
                    label="Modelo de Avaliação"
                  >
                    {templates.map((template) => (
                      <MenuItem key={template.id} value={template.id}>
                        {template.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            
            <Grid item xs={12}>
                <FormControl fullWidth required>
                  <InputLabel>Projeto</InputLabel>
                  <Select
                    name="projectId"
                    value={formData.projectId}
                    onChange={handleInputChange}
                    label="Projeto"
                  >
                  {projects.map((project) => (
                    <MenuItem key={project.id} value={project.id}>
                      {project.title}
                    </MenuItem>
                  ))}
                  </Select>
                </FormControl>
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Título da Avaliação"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                placeholder={selectedTemplate ? selectedTemplate.title : "Título da avaliação"}
              />
            </Grid>
            
            {/* Removido campo de expiração */}
            
            {/* Removidos campos de envio por email na criação de avaliação */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCreateDialog}>Cancelar</Button>
          <Button 
            onClick={handleCreateEvaluation} 
            variant="contained" 
            color="primary"
            disabled={!formData.projectId || (!formData.templateId && !selectedTemplate)}
          >
            Criar Avaliação
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Diálogo para visualizar avaliação */}
      <Dialog open={openPreviewDialog} onClose={handleClosePreviewDialog} maxWidth="md" fullWidth>
        <DialogTitle>
          {selectedEvaluation ? selectedEvaluation.title : selectedTemplate?.title}
        </DialogTitle>
        <DialogContent>
          {selectedTemplate && (
            <Box sx={{ mt: 2 }}>
              <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
                <Step key="intro">
                  <StepLabel>Introdução</StepLabel>
                </Step>
                <Step key="questions">
                  <StepLabel>Perguntas</StepLabel>
                </Step>
                <Step key="submit">
                  <StepLabel>Envio</StepLabel>
                </Step>
              </Stepper>
              
              {activeStep === 0 && (
                <Box>
                  <Typography variant="h6" gutterBottom>
                    Bem-vindo à {selectedEvaluation ? selectedEvaluation.title : selectedTemplate.title}
                  </Typography>
                  <Typography variant="body1" paragraph>
                    {selectedTemplate.description}
                  </Typography>
                  <Typography variant="body1" paragraph>
                    Esta avaliação contém {Array.isArray(selectedTemplate?.questions) ? selectedTemplate.questions.length : 0} perguntas e levará aproximadamente {Array.isArray(selectedTemplate?.questions) ? Math.ceil(selectedTemplate.questions.length * 0.5) : 0} minutos para ser concluída.
                  </Typography>
                  <Typography variant="body1" paragraph>
                    Suas respostas são importantes para melhorarmos continuamente nossos serviços. Obrigado por participar!
                  </Typography>
                  
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                    <Button
                      variant="contained"
                      onClick={handleNext}
                    >
                      Começar
                    </Button>
                  </Box>
                </Box>
              )}
              
              {activeStep === 1 && (
                <Box>
                  <Typography variant="h6" gutterBottom>
                    Perguntas
                  </Typography>
                  
                  {(() => {
                    const descMap = {
                      'Dados Demográficos': 'Ajude-nos a compreender o perfil dos participantes.',
                      'Dados da Empresa': 'Informação geral sobre a organização.',
                      'Aprendizagem e Dinâmica do Grupo': 'Avalie como a ação promoveu a aprendizagem e a dinâmica entre os participantes.',
                      'Qualidade do Programa': 'Avalie a utilidade, organização e duração do curso.',
                      'Qualidade dos Meios de Apoio': 'Avalie os recursos físicos e materiais disponibilizados.',
                      'Desempenho da Equipa Pedagógica': 'Avalie a equipa pedagógica e o apoio prestado.',
                      'Satisfação Global da Ação': 'Avalie a satisfação geral com a ação.',
                      'Relevância': 'Avalie a relevância dos conteúdos e da experiência de aprendizagem.',
                      'Alinhamento Estratégico': 'Avalie a ligação da formação aos objetivos estratégicos.',
                      'Adaptação e Inovação': 'Avalie a capacidade de adaptação e inovação fomentada.',
                      'Produtividade e Qualidade': 'Avalie impactos na produtividade e qualidade.',
                      'Impacto Financeiro': 'Avalie redução de custos e ROI.',
                      'Gestão de Pessoas': 'Avalie motivação, retenção e colaboração.',
                      'Competitividade': 'Avalie impactos na competitividade e oportunidades de negócio.',
                      'Indicadores Concretos': 'Registe impactos mensuráveis e observações.',
                      'Opiniões e sugestões (Respostas livres)': 'Partilhe sugestões e observações.'
                    };
                    const order = [
                      'Dados Demográficos',
                      'Dados da Empresa',
                      'Aprendizagem e Dinâmica do Grupo',
                      'Qualidade do Programa',
                      'Qualidade dos Meios de Apoio',
                      'Desempenho da Equipa Pedagógica',
                      'Satisfação Global da Ação',
                      'Relevância',
                      'Alinhamento Estratégico',
                      'Adaptação e Inovação',
                      'Produtividade e Qualidade',
                      'Impacto Financeiro',
                      'Gestão de Pessoas',
                      'Competitividade',
                      'Indicadores Concretos',
                      'Opiniões e sugestões (Respostas livres)'
                    ];
                    const groups = {};
                    const qs = selectedTemplate?.questions || [];
                    qs.forEach((q) => {
                      const t = String(q.text || '');
                      const g = t.includes('—') ? t.split('—')[0].trim() : t;
                      if (!groups[g]) groups[g] = [];
                      groups[g].push(q);
                    });
                    return (
                      <List>
                        {order.filter((g) => groups[g]).map((grp) => (
                          <React.Fragment key={`grp-${grp}`}>
                            <ListItem alignItems="flex-start" sx={{ flexDirection: 'column', py: 1 }}>
                              <Typography variant="subtitle1" sx={{ mb: 0.5 }}>{grp}</Typography>
                              {descMap[grp] && <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>{descMap[grp]}</Typography>}
                              {groups[grp].map((question) => {
                                const label = String(question.text || '').includes('—') ? String(question.text).split('—')[1].trim() : String(question.text || '');
                                return (
                                  <Box key={question.id} sx={{ width: '100%', pl: 1, mb: 2 }}>
                                    <Typography variant="body2" sx={{ mb: 0.5 }}>{label}{question.required ? ' *' : ''}</Typography>
                                    {question.type === 'rating' && (
                                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Typography variant="caption" color="text.secondary" sx={{ mr: 2 }}>1 Insuficiente · 2 Suficiente · 3 Médio · 4 Bom · 5 Excelente · Não se aplica</Typography>
                                        <Rating name={`rating-${question.id}`} value={typeof previewAnswers[question.id] === 'number' ? previewAnswers[question.id] : 0} onChange={(event, newValue) => { handleAnswerChange(question.id, newValue); }} />
                                        <FormControlLabel sx={{ ml: 2 }} control={<Checkbox checked={previewAnswers[question.id] === 'na'} onChange={(e) => handleAnswerChange(question.id, e.target.checked ? 'na' : 0)} />} label="Não Responde/Não se aplica" />
                                      </Box>
                                    )}
                                    {question.type === 'text' && (
                                      <TextField fullWidth multiline rows={3} value={previewAnswers[question.id] || ''} onChange={(e) => handleAnswerChange(question.id, e.target.value)} />
                                    )}
                                    {question.type === 'yesno' && (
                                      <FormControl component="fieldset">
                                        <RadioGroup row name={`yesno-${question.id}`} value={previewAnswers[question.id] || ''} onChange={(e) => handleAnswerChange(question.id, e.target.value)}>
                                          <FormControlLabel value="yes" control={<Radio />} label="Sim" />
                                          <FormControlLabel value="no" control={<Radio />} label="Não" />
                                        </RadioGroup>
                                      </FormControl>
                                    )}
                                    {question.type === 'choice' && Array.isArray(question.options) && (
                                      <FormControl component="fieldset">
                                        <RadioGroup name={`choice-${question.id}`} value={previewAnswers[question.id] || ''} onChange={(e) => handleAnswerChange(question.id, e.target.value)}>
                                          {question.options.map((opt) => (
                                            <FormControlLabel key={`${question.id}-${opt}`} value={opt} control={<Radio />} label={opt} />
                                          ))}
                                        </RadioGroup>
                                      </FormControl>
                                    )}
                                  </Box>
                                );
                              })}
                            </ListItem>
                            <Divider component="li" />
                          </React.Fragment>
                        ))}
                      </List>
                    );
                  })()}
                  
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                    <Button
                      onClick={handleBack}
                    >
                      Voltar
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleNext}
                    >
                      Continuar
                    </Button>
                  </Box>
                </Box>
              )}
              
              {activeStep === 2 && (
                <Box sx={{ textAlign: 'center' }}>
                  <CheckCircleIcon color="success" sx={{ fontSize: 60, mb: 2 }} />
                  <Typography variant="h6" gutterBottom>
                    Obrigado por completar a avaliação!
                  </Typography>
                  <Typography variant="body1" paragraph>
                    Suas respostas foram registradas com sucesso.
                  </Typography>
                  <Typography variant="body1" paragraph>
                    Sua opinião é muito importante para nós e nos ajudará a melhorar continuamente nossos serviços.
                  </Typography>
                  
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Button
                      variant="outlined"
                      onClick={handleBack}
                      sx={{ mr: 2 }}
                    >
                      Voltar
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleClosePreviewDialog}
                    >
                      Concluir
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Removido diálogo de convites gerados */}

      {/* Diálogo de Resultados da Avaliação */}
      <Dialog open={openResultsDialog} onClose={() => setOpenResultsDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Resultados da Avaliação</DialogTitle>
        <DialogContent id="eval-results-root">
          {!resultsEvaluation ? (
            <LinearProgress />
          ) : (
            <Box>
              <Typography variant="subtitle1" gutterBottom>
                {resultsEvaluation.title}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Typography variant="body2" color="text.secondary">Link público:</Typography>
                <Button
                  size="small"
                  startIcon={<LinkIcon />}
                  onClick={() => navigator.clipboard.writeText(`${window.location.origin}/public/evaluation/by-id/${resultsEvaluation.id || ''}`)}
                >
                  Copiar
                </Button>
                <Button size="small" variant="outlined" onClick={async () => {
                  const node = document.getElementById('eval-results-root');
                  if (!node) return;
                  const canvas = await html2canvas(node, { scale: 2, useCORS: true });
                  const imgData = canvas.toDataURL('image/png');
                  const pdf = new jsPDF('p', 'mm', 'a4');
                  const pageWidth = pdf.internal.pageSize.getWidth();
                  const pageHeight = pdf.internal.pageSize.getHeight();
                  const margin = 10;
                  const imgWidth = pageWidth - margin * 2;
                  const imgHeight = (canvas.height * imgWidth) / canvas.width;
                  let y = margin;
                  if (imgHeight <= pageHeight - y - margin) {
                    pdf.addImage(imgData, 'PNG', margin, y, imgWidth, imgHeight);
                  } else {
                    let remainingHeight = imgHeight;
                    let sY = 0;
                    const scale = imgWidth / canvas.width;
                    const pageContentHeight = pageHeight - y - margin;
                    while (remainingHeight > 0) {
                      const sliceHeightPx = pageContentHeight / scale;
                      const sliceCanvas = document.createElement('canvas');
                      sliceCanvas.width = canvas.width;
                      sliceCanvas.height = Math.min(sliceHeightPx, canvas.height - sY);
                      const ctx = sliceCanvas.getContext('2d');
                      ctx.drawImage(canvas, 0, sY, canvas.width, sliceCanvas.height, 0, 0, canvas.width, sliceCanvas.height);
                      const sliceImg = sliceCanvas.toDataURL('image/png');
                      pdf.addImage(sliceImg, 'PNG', margin, y, imgWidth, (sliceCanvas.height * imgWidth) / canvas.width);
                      remainingHeight -= (sliceCanvas.height * imgWidth) / canvas.width;
                      sY += sliceCanvas.height;
                      if (remainingHeight > 0) {
                        pdf.addPage();
                        y = margin;
                      }
                    }
                  }
                  const dateStr = new Date().toISOString().slice(0, 10);
                  pdf.save(`resultados_avaliacao_${resultsEvaluation.id || ''}_${dateStr}.pdf`);
                }}>Exportar PDF</Button>
              </Box>
              <Divider sx={{ my: 1 }} />
              <Typography variant="body2" gutterBottom>
                Concluídos: {(resultsEvaluation.assignments || []).filter(a => a.status === 'completed').length}
              </Typography>
              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom>Resumo por pergunta</Typography>
              {Array.isArray(resultsEvaluation.questions) && resultsEvaluation.questions.length ? (
                <List>
                  {resultsEvaluation.questions.map((q, idx) => {
                    const qid = (typeof q.id !== 'undefined' && q.id !== null) ? q.id : idx;
                    const completed = (resultsEvaluation.assignments || []).filter(a => a.status === 'completed');
                    const values = completed.map(a => {
                      const ans = a.answers || {};
                      return (typeof ans[qid] !== 'undefined') ? ans[qid] : ans[idx];
                    }).filter(v => typeof v !== 'undefined' && v !== null);
                    let summary = '';
                    if (q.type === 'rating') {
                      const nums = values.map(v => Number(v)).filter(n => !Number.isNaN(n));
                      const avg = nums.length ? (nums.reduce((s, n) => s + n, 0) / nums.length).toFixed(2) : '—';
                      summary = `Média: ${avg} (${nums.length} respostas)`;
                    } else if (q.type === 'yesno') {
                      const yes = values.filter(v => String(v).toLowerCase() === 'yes').length;
                      const no = values.filter(v => String(v).toLowerCase() === 'no').length;
                      summary = `Sim: ${yes} · Não: ${no} (total ${yes + no})`;
                    } else if (q.type === 'choice') {
                      const opts = Array.isArray(q.options) ? q.options : [];
                      const counts = opts.map(o => ({ o, c: values.filter(v => String(v) === String(o)).length }));
                      summary = counts.length ? counts.map(({o,c}) => `${o}: ${c}`).join(' · ') : `Respostas: ${values.length}`;
                    } else if (q.type === 'text') {
                      const texts = values.map(v => String(v)).filter(t => t && t.trim().length);
                      summary = texts.length ? `Respostas: ${texts.length}` : 'Sem respostas textuais';
                    } else {
                      summary = `Respostas: ${values.length}`;
                    }
                    const label = String(q.text || '').includes('—') ? String(q.text).split('—')[1].trim() : String(q.text || 'Pergunta');
                    const group = String(q.text || '').includes('—') ? String(q.text).split('—')[0].trim() : '';
                    return (
                      <ListItem key={qid} alignItems="flex-start" sx={{ flexDirection: 'column' }}>
                        {group && <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5 }}>{group}</Typography>}
                        <Typography variant="subtitle1" sx={{ mb: 0.5 }}>{idx + 1}. {label}</Typography>
                        <Typography variant="body2" color="text.secondary">{summary}</Typography>
                        {q.type === 'text' && values.length ? (
                          <Box sx={{ mt: 1, width: '100%' }}>
                            {values.slice(0, 5).map((t, i) => (
                              <Typography key={i} variant="body2" sx={{ mb: 0.5 }}>• {String(t)}</Typography>
                            ))}
                            {values.length > 5 && (
                              <Typography variant="caption" color="text.secondary">(+{values.length - 5} mais)</Typography>
                            )}
                          </Box>
                        ) : null}
                      </ListItem>
                    );
                  })}
                </List>
              ) : (
                <Alert severity="info">Esta avaliação não tem perguntas registadas.</Alert>
              )}
              {/* Lista de assignments removida; link público único acima */}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenResultsDialog(false)}>Fechar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Evaluations;
